import React from 'react';

export default (Component, type, media_view) => (props) => (
    <Component type={type} media_view={media_view} {...props} />
);
